import Const from '@/helpers/const'
import axios from 'axios'

export default {
  verifyUseTimeline (params) {
    return axios.get(`${Const.API_USE_TIMELINE}?iesid=${params.iesid}&tenantid=${params.tenantid}`)
  },
  updateTimelineV2 (discipline) {
    return axios.post(`${Const.API_UPDATE_TIMELINE_V2}`, discipline)
  }
}
